module.exports = __webpack_public_path__ + "img/mind_template_item_2_1.3d394246.png";